import { useEffect, useState } from "react";
import {
  getOrganizationMembers,
  getCollegeSuggestions,
  getAllNationalOrganizationSuggestions,
  getChildSuggestions,
} from "../../../../services/axios";
import Select from "react-select";
import { Member, OrganizationType } from "../../../../utils/types";

const menuOptions = [
  "College",
  "Panhellenic",
  "IFC",
  "Multicultural Greeks",
  "NPHC",
  "Pre-Professional",
  "Official Sports",
  "Student Organization",
  "Club Sports",
  "Program",
  "Department",
  "Dance Marathon",
  "Alumni Associations",
];

export function OrganizationSelector({
  setSelectedParentOrganizations,
  selectedParentOrganizations,
  setSelectedChildOrganizations,
  selectedChildOrganizations,
  setSelectedMemberOrganizations,
  selectedMemberOrganizations,
}: {
  setSelectedParentOrganizations: (e: any) => void;
  selectedParentOrganizations: { label: string; value: OrganizationType }[];
  setSelectedChildOrganizations: (e: any) => void;
  selectedChildOrganizations: { label: string; value: OrganizationType }[];
  setSelectedMemberOrganizations: (e: any) => void;
  selectedMemberOrganizations: { label: string; value: Member }[];
}) {
  const menus = menuOptions.map(function (menu_name) {
    return {
      value: menu_name,
      label: menu_name,
    };
  });
  const [selectedMenu, setSelectedMenu] = useState<any>();
  const [selectedCollegeMenu, setSelectedCollegeMenu] = useState<any>();
  const [parentSearch, setParentSearch] = useState("");
  const [suggestionsParents, setSuggestionsParents] = useState([]);
  const [suggestionsChild, setSuggestionsChild] = useState([]);
  const [suggestionsMembers, setSuggestionsMembers] = useState([]);

  // get parent organizations
  useEffect(() => {
    (async () => {
      if (!selectedMenu?.value) return;
      if (selectedMenu?.value === "College") {
        if (parentSearch) {
          setTimeout(async () => {
            const res = await getCollegeSuggestions(parentSearch);
            if (!res) {
              return;
            }
            const next =
              res?.map((item) => {
                return {
                  value: item,
                  label: item.full_name + " - " + item.salesforce_id,
                };
              }) || [];
            if (!next) {
              return;
            }
            // @ts-ignore
            setSuggestionsParents(next);
          }, 500);
        } else {
          const res = await getCollegeSuggestions("");
          const next =
            res?.map((item) => {
              return {
                value: item,
                label: item.full_name + " - " + item.salesforce_id,
              };
            }) || [];
          if (!next) {
            return;
          }
          // @ts-ignore
          setSuggestionsParents(next);
        }
      } else {
        // national organizations
        const res = await getAllNationalOrganizationSuggestions(
          selectedMenu?.value
        );
        const next =
          res?.map((item) => {
            return {
              value: item,
              label: item.full_name + " - " + item.salesforce_id,
            };
          }) || [];
        if (!next) {
          return;
        }
        // @ts-ignore
        setSuggestionsParents(next);
      }
    })();
  }, [selectedMenu?.value, selectedParentOrganizations, parentSearch]);

  // get campus organizations
  useEffect(() => {
    (async () => {
      if (!selectedParentOrganizations) return;
      let ids = selectedParentOrganizations.map((x) => x.value.salesforce_id);
      if (ids.length >= 1) {
        let result = await getChildSuggestions(
          ids,
          selectedCollegeMenu ? selectedCollegeMenu.value : ""
        ).then((res) => {
          if (!res) {
            return;
          }
          return res.map(function (item) {
            return {
              value: item,
              label: item.full_name + " - " + item.salesforce_id,
            };
          });
        });
        if (!result) {
          return;
        }
        let promised = await (await Promise.all(result)).flat();
        if (!promised) {
          return;
        }
        // @ts-ignore
        setSuggestionsChild(promised);
      }
    })();
  }, [selectedParentOrganizations, selectedMenu?.value, selectedCollegeMenu]);

  // get athletes
  useEffect(() => {
    (async () => {
      if (!selectedChildOrganizations) return;
      let athleteData = [];
      for (let i = 0; i < selectedChildOrganizations.length; i++) {
        const salesforce_id = selectedChildOrganizations[i].value.salesforce_id;
        const athletes = await getOrganizationMembers(salesforce_id);
        for (let a = 0; a < athletes.length; a++) {
          let item = athletes[a];
          athleteData.push({
            value: item,
            label: item.full_name + "-" + item.salesforce_id,
          });
        }
      }
      const next = athleteData.filter(
        (member) => member.value.status.toLowerCase() === "active"
      );
      if (!next) {
        return;
      }
      // @ts-ignore
      setSuggestionsMembers(next);
    })();
  }, [selectedChildOrganizations]);

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <div className="flex-1 min-w-0 mt-4">
          <p>Select Organization Category</p>
        </div>
      </div>
      <div className="mt-2">
        <Select
          isSearchable
          isClearable
          name="Categories"
          options={menus}
          value={selectedMenu}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(e) => setSelectedMenu(e)}
        />
      </div>
      {selectedMenu?.value && (
        <div className="mt-4">
          <div className="w-full flex flex-row justify-between items-center">
            <div className="flex flex-row justify-between items-center">
              <div className="flex-1 min-w-0 mt-4">
                Select an {selectedMenu?.value} organization
              </div>
            </div>
            <button
              className="px-4 py-2 border rounded-full my-4"
              onClick={() => {
                setSelectedParentOrganizations(suggestionsParents);
              }}
            >
              Select All
            </button>
          </div>
          <Select
            isSearchable
            isClearable
            isMulti
            name="Organizations"
            options={suggestionsParents}
            value={selectedParentOrganizations}
            className="basic-multi-select"
            classNamePrefix="select"
            onInputChange={(e) => setParentSearch(e)}
            onChange={(e) => setSelectedParentOrganizations(e)}
          />
        </div>
      )}
      {selectedMenu?.value && selectedMenu?.value === "College" && (
        <div className="mt-4">
          <div className="flex flex-row justify-between items-center">
            <div className="flex-1 min-w-0 mt-4">Select a Campus Category</div>
          </div>
          <Select
            isSearchable
            isClearable
            name="Categories"
            options={menus}
            value={selectedCollegeMenu}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(e) => setSelectedCollegeMenu(e)}
          />
        </div>
      )}
      {selectedMenu?.value && selectedParentOrganizations && (
        <div className="mt-4">
          <div className="w-ful flex flex-row justify-between items-center">
            <div className="flex flex-row justify-between items-center">
              <div className="flex-1 min-w-0 mt-4">
                Select Campus Organizations
              </div>
            </div>
            <button
              className="px-4 py-2 border rounded-full my-4"
              onClick={() => {
                setSelectedChildOrganizations(suggestionsChild);
              }}
            >
              Select All
            </button>
          </div>
          <Select
            isSearchable
            isClearable
            isMulti
            name="parents"
            options={suggestionsChild}
            value={selectedChildOrganizations}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(e) => setSelectedChildOrganizations(e)}
          />
        </div>
      )}
      {selectedChildOrganizations?.length > 0 && (
        <div className="mt-4">
          <div className="w-full flex flex-row justify-between items-center">
            <div className="flex flex-row justify-between items-center">
              <div className="flex-1 min-w-0 mt-4">Members</div>
            </div>
            <button
              className="px-4 py-2 border rounded-full my-4"
              onClick={() => {
                setSelectedMemberOrganizations(suggestionsMembers);
              }}
            >
              Select All
            </button>
          </div>
          <Select
            isSearchable
            isMulti
            isClearable
            name="Members"
            options={suggestionsMembers}
            value={selectedMemberOrganizations}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(e) => {
              setSelectedMemberOrganizations(e);
            }}
          />
        </div>
      )}
    </div>
  );
}
